/**
 * Generate the <Link rel="preload" as="image" ... /> for the hero images. (mobile & desktop)
 */
import type { MetaDescriptor } from '@remix-run/node';
import { imageConfig } from '@modules/images';
import type { ImageLoader } from '@archipro-design/aria';

export const getPreloadImageLink = (
    imageDesktop?: string,
    imageMobile?: string,
    imageSizes?: string
): MetaDescriptor[] => {
    const defaultLinksAttr = {
        rel: 'preload',
        as: 'image',
        tagName: 'link',
    };
    const dynamicImageLinks: MetaDescriptor[] = [];
    const loader = imageConfig.loader;

    if (imageDesktop) {
        dynamicImageLinks.push({
            ...defaultLinksAttr,
            href: loader({
                src: imageDesktop,
                width: 3840,
            }),
            media: '(min-width: 1024px)',
            imageSrcSet: generateImageSrcSet(loader, imageDesktop),
            imageSizes: imageSizes || '100vw',
        });
    }

    if (imageMobile) {
        dynamicImageLinks.push({
            ...defaultLinksAttr,
            href: loader({
                src: imageMobile,
                width: 3840,
            }),
            media: '(max-width: 768px)',
            imageSrcSet: generateImageSrcSet(loader, imageMobile),
            imageSizes: imageSizes || '100vw',
        });
    }

    return dynamicImageLinks;
};

// No-export, only for usage in getPreloadImageLink
const generateImageSrcSet = (loader: ImageLoader, src: string): string => {
    const deviceSizes = imageConfig.deviceSizes;

    return deviceSizes
        .map((w) => {
            return `${loader({
                src: src,
                width: w,
            })} ${w}w`;
        })
        .join(',');
};
